import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-opening_order",
  "use": "icon-opening_order-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-opening_order\"><path d=\"M710.776 90.353H192.753c-72.282 0-132.518 54.212-132.518 120.47v662.589c0 66.259 60.236 120.47 132.518 120.47h584.282c72.283 0 132.518-54.211 132.518-120.47V331.294h-60.235v542.118c0 30.117-30.118 60.235-72.283 60.235H192.753c-42.165 0-72.282-30.118-72.282-60.235V210.824c0-30.118 30.117-60.236 72.282-60.236h518.023V90.353z\" /><path d=\"M246.965 391.53H548.14v-60.236H246.965zm0 180.705h481.882V512H246.965zm0 180.706h481.882v-60.235H246.965zm427.67-385.506l289.13-295.153L921.6 30.118 632.47 325.27z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/opening_order.svg
// module id = ZLWe
// module chunks = 78